import { createApp } from "vue"
export default ({ app, props, el, router }) => {
  const a = createApp(app, props || {})
  if (router) a.use(router)
  return a.mount(el)
}
